import Animation from './animation';

const animationConfig = {
  name: 'animation',
  class: Animation,
  querySelectorAll: {
    animatedBlocks: '.has-animation',
  },
};

export default animationConfig;
